import _ from 'lodash';
import React from 'react';
import Debug from 'debug';
import Collection from '../../models/Collection';
import Store from '../../models/Store';
import Alert from '../Alert';
import CollectionActions from '../../actions/CollectionActions';
import ShoppingCartActions from '../../actions/ShoppingCartActions';
import Image from '../Image';
import shallowCompare from '../../lib/shallowCompare';
import CollectionItem from './CollectionItem';
import AttributedText from '../AttributedText';
import styles from './index.sass';

const debug = Debug('delectable');

class CollectionDetail extends React.Component {
  static propTypes = {
    collection: React.PropTypes.instanceOf(Collection),
    store: React.PropTypes.instanceOf(Store),
    pagination: React.PropTypes.object,
    loading: React.PropTypes.bool
  };

  static contextTypes = {
    executeAction: React.PropTypes.func,
    getStore: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: props.loading,
      requestedOffset: 0,
      addAllAlertOpen: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.collection && nextProps.collection && nextProps.collection.id !== this.props.collection.id) {
      this.setState({requestedOffset: 0});
    }
    if(this.props.loading !== nextProps.loading) {
      this.setState({loading: nextProps.loading});
    }
  }

  handleOnClickLoadMoreButton(e) {
    let offset = this.props.pagination.offset + this.props.pagination.limit;
    if(offset <= this.state.requestedOffset) {return;}
    this.setState({
      loading: true,
      requestedOffset: offset
    });
    this.context.executeAction(CollectionActions.fetch, {
      slug: this.props.collection.slug,
      pagination: _.extend({}, this.props.pagination, {offset: offset})
    });
  }

  handleOnClickAddAllButton(e) {
    this.setState({addAllAlertOpen: true});
    if(this.props.collection.items.size < this.props.pagination.totalResults) {
      let remainder = this.props.pagination.totalResults - this.props.collection.items.size;
      let offset = this.props.pagination.offset + this.props.pagination.limit;
      if(offset <= this.state.requestedOffset) {return;}
      this.setState({
        loading: true,
        requestedOffset: offset
      });
      this.context.executeAction(CollectionActions.fetch, {
        slug: this.props.collection.slug.slug,
        pagination: _.extend({}, this.props.pagination, {offset: offset, limit: remainder})
      });
    }
  }

  renderAddAllAlert() {
    if(!this.state.addAllAlertOpen) {return null;}
    let itemsToAdd = [];
    for (let i = 0; i < this.props.collection.items.size; i++) {
      let item = this.props.collection.items.get(i);
      if (!['sold_out', 'unavailable'].includes(item.availability)) {
        itemsToAdd.push(item);
      }
    }
    let alertProps = {
      title: `Add items?`,
      body: <div>
        <div>Are you sure you want to add all items from <span style={{fontWeight: 500}}>{this.props.collection.title}</span>?</div>
        <br />
        <div>*Sold Out or Unavailable items will not be added to your cart.</div>
      </div>,
      confirmButtonText: `Add all`,
      onCancel: () => {
        this.setState({addAllAlertOpen: false});
      },
      onConfirm: () => {
        this.setState({addAllAlertOpen: false});
        for (let i = 0; i < itemsToAdd.length; i++) {
          let item = itemsToAdd[i];
          let addItemProps = {
            store_id: this.props.collection.store_id,
            inventory_record_id: item.inventory_record.id,
            quantity: 1,
            inventory_record: item.inventory_record
          };
          if (i == itemsToAdd.length - 1) {
            addItemProps.navigateToBagOnSuccess = true;
          }
          this.context.executeAction(ShoppingCartActions.addItem, addItemProps);
        }
      }
    };
    return <Alert {...alertProps} />;
  }

  renderItems() {
    let items = this.props.collection.items;
    if(!items || !items.size) {return null;}
    let elems = items.map(item => {
      let itemProps = {
        item: item,
        storeId: this.props.collection.store_id,
        collection: this.props.collection,
        key: item.getIn(['inventory_record', 'id'])
      };
      return <CollectionItem {...itemProps} />;
    });
    if(this.state.loading) {
      elems = elems.push(<span key="loadingspinner" className="loading-spinner--teal" style={{display: 'block', marginTop: 60, marginBottom: 50}} />);
    }
    return elems;
  }

  render() {
    let {collection, store} = this.props;
    if(!collection || !store) {
      return (
        <div className={`${styles.collection} ${styles.loading}`}>
          <h1 className={styles.title} />
          <p className={styles.published} />
          <div className={styles.header} />
        </div>
      );
    }
    let storeSlug = store.slug;
    let coverPhotoUrl = collection.cover_photo_hash.getClosestToTarget(1280);
    let imageProps = {
      tag: 'div',
      aspectRatio: (940/450),
      mobileAspectRatio: (343 / 200),
      targetWidth: 1280,
      photoHash: collection.cover_photo_hash
    };
    let loadMoreButton;
    if(!this.state.loading && collection.items.size < this.props.pagination.totalResults) {
      let loadMoreButtonProps = {
        className: styles.loadMoreButton,
        onClick: this.handleOnClickLoadMoreButton.bind(this)
      };
      loadMoreButton = <button {...loadMoreButtonProps}>See more</button>;
    }
    let addAllButton;
    let addAllButtonProps = {
      className: styles.addAllButton,
      onClick: this.handleOnClickAddAllButton.bind(this)
    };
    addAllButton = <button {...addAllButtonProps}>Add All to Cart</button>;

    return (
      <div className={styles.collection} itemScope itemType="http://schema.org/ItemList">
        <h1 className={styles.title} itemProp="name">{collection.title}</h1>
        <p className={styles.published}>{collection.published_at}</p>
        <div className={styles.header}>
          <Image {...imageProps} />
        </div>
        <span itemProp="image" content={coverPhotoUrl} />
        <p className={styles.description} itemProp="description" dangerouslySetInnerHTML={{__html: collection.description.replace(/\n/g, '<br/>')}}></p>
        <div className={styles.addAllWrapper}>
          {addAllButton}
        </div>
        <div className={styles.itemsList}>
          {this.renderItems()}
        </div>
        <div className={styles.loadMoreWrapper}>
          {loadMoreButton}
        </div>
        {this.renderAddAllAlert()}
      </div>
    );
  }
}

export default CollectionDetail;



// WEBPACK FOOTER //
// banquet/components/CollectionDetail/index.js